import { Flex, Text } from '@raystack/apsara';

import { Slider } from '@src/components/Custom/Slider/slider';
import { Show } from '@src/hoc';

import styles from './styles.module.css';

const OverlaySlider = ({
  title = '',
  value,
  onChange,
  'data-test-id': testId
}) => {
  return (
    <Flex align='center' gap='small' style={{ width: '80%' }}>
      <Show when={title.length > 0}>
        <Text
          size={1}
          weight={500}
          variant='tertiary'
          style={{ whiteSpace: 'nowrap' }}
        >
          {title}
        </Text>
      </Show>
      <Slider
        min={0}
        max={1}
        step={0.1}
        value={value}
        data-test-id={testId}
        onChange={onChange}
        classNames={styles.fullWidth}
      />
      <Text size={1} weight={500} variant='tertiary'>
        {value[0]}
      </Text>
    </Flex>
  );
};

export default OverlaySlider;
